import { render, staticRenderFns } from "./pageContainer.vue?vue&type=template&id=4d1219c4&scoped=true&"
import script from "./pageContainer.vue?vue&type=script&lang=js&"
export * from "./pageContainer.vue?vue&type=script&lang=js&"
import style0 from "./pageContainer.vue?vue&type=style&index=0&id=4d1219c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1219c4",
  null
  
)

export default component.exports